import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-homepage-service-provider',
    templateUrl: './homepage-service-provider.component.html',
    styleUrls: ['./homepage-service-provider.component.scss'],
    standalone: false
})
export class HomepageServiceProviderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
